import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

const request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
});

/**
 * Servicio HTTP para la Configuración de Artículos Cíclicos
 */
export default class CiclicosConfigRequest {
    /**
     * Obtener el catálogo de frecuencias (Diaria Base, Diaria Adicional, Semanal)
     */
    static ListarFrecuencias() {
        return middleware.hasAuth(() => request.get('ciclicos/frecuencias'));
    }

    /**
     * Obtener artículos disponibles para agregar a una frecuencia mediante GET
     * @param {Object} data - { frecuencia_id, pdv_id, search, page, page_size }
     */
    static ListarArticulosDisponibles(data) {
        return middleware.hasAuth(() => request.get('ciclicos/articulos-disponibles', { params: data }));
    }

    /**
     * Obtener la lista de configuraciones activas e indicadores de totales mediante GET
     * @param {Object} data - { pdv_id, frecuencia_id, search, page, page_size }
     */
    static ListarConfiguraciones(data) {
        return middleware.hasAuth(() => request.get('ciclicos/articulos', { params: data }));
    }

    /**
     * Guardar una o varias reglas de configuración
     * @param {Object} data - { articulos: [], frecuencia_id, pdv_id }
     */
    static GuardarConfiguraciones(data) {
        return middleware.hasAuth(() => request.post('ciclicos/articulos', data));
    }

    /**
     * Consultar de forma paginada los Puntos de Venta configurados para un artículo específico
     * @param {number} idArticuloInventario - ID del artículo
     * @param {Object} data - { frecuencia_id, page, page_size }
     */
    static ListarSucursalesArticulo(idArticuloInventario, data) {
        return middleware.hasAuth(() => request.get(`ciclicos/articulos/${idArticuloInventario}/sucursales`, { params: data }));
    }

    /**
     * Eliminar uno o varios artículos de todos los PDVs/frecuencias (Exclusivo Administrador)
     * @param {number[]} articuloIds - IDs de artículos
     */
    static EliminarArticulosMasivoLote(articuloIds) {
        return middleware.hasAuth(() => request.delete('ciclicos/articulos/eliminar-masivo-lote', { data: { articulos: articuloIds } }));
    }

    /**
     * Eliminar una o varias configuraciones puntuales por su id
     * @param {number[]} ids - IDs de reglas de configuración
     */
    static EliminarConfiguracionesLote(ids) {
        return middleware.hasAuth(() => request.delete('ciclicos/articulos/eliminar-lote', { data: { ids } }));
    }
}
